import { Card, CardHeader, Flex, Heading, CardContent, Row } from "@ir/ui";
import { Credit } from "@/core/entities/credit";
import { useWorkspace } from "@/hooks";
import { DateService, NumberFormatterService } from "@/core/services";
import { DateAdapter } from "@/infrastructure/adapters/dayJs";
import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";
import CreditDrawerInfoCol from "./CreditDrawerInfoCol";
import { CreditInformationLabels } from "./utils/creditInformationLabel.enum";

interface CreditInformationProps {
  credit: Credit | null;
  isLoading: boolean;
}

const CreditInformation = ({ credit, isLoading }: CreditInformationProps) => {
  const { settings: workspaceSettings } = useWorkspace();

  const formatDate = (date: string | null | undefined) => {
    if (!date) return undefined;
    if (workspaceSettings?.displayDateFormat) {
      return new DateService(new DateAdapter()).format(date, workspaceSettings.displayDateFormat);
    }
    return date;
  };

  const formatAmount = (amount: number | null | undefined) => {
    if (amount == null) return undefined;
    if (workspaceSettings?.displayNumberFormat) {
      return (
        "$" + new NumberFormatterService(new NumberFormatterAdapter()).format(amount, workspaceSettings.displayNumberFormat)
      );
    }
    return amount;
  };

  const creditDetailsInformation = [
    { label: CreditInformationLabels.CheckNumber, value: credit?.checkNumber },
    { label: CreditInformationLabels.CheckDate, value: formatDate(credit?.checkDate) },
    { label: CreditInformationLabels.InvoiceNumber, value: credit?.invoiceNumber },
    { label: CreditInformationLabels.InvoiceDate, value: formatDate(credit?.invoiceDate) },
    { label: CreditInformationLabels.Purchaser, value: credit?.purchaser?.purchaserName },
    { label: CreditInformationLabels.GrossAmount, value: formatAmount(credit?.grossAmount) },
    { label: CreditInformationLabels.NetAmount, value: formatAmount(credit?.netAmount) },
    { label: CreditInformationLabels.PONumber, value: credit?.poNumber }
  ];

  return (
    <Card className="bg-white mb-3">
      <CardHeader className="py-2">
        <Flex justifyContent="space-between" align="center">
          <Heading level={6} className="text-grey-700 font-bold m-0">
            Details
          </Heading>
        </Flex>
      </CardHeader>
      <CardContent>
        <Flex>
          <Row className="flex-1">
            {creditDetailsInformation.map(item => (
              <CreditDrawerInfoCol
                key={item.label}
                label={item.label}
                value={item.value}
                isLoading={isLoading}
              />
            ))}
          </Row>
        </Flex>
      </CardContent>
    </Card>
  );
};

export default CreditInformation;
